__turbopack_context__.v({
  "asset-link": "asset-link-component-module-scss-module__-7UFLq__asset-link",
});
